import React, { useState ,useEffect } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { connect } from 'react-redux';
import UncheckIcon from './../../assets/nav/uncheck-box.svg'
import CheckIcon from './../../assets/nav/check-box.svg'
import { notifyError } from '../../Utils';

const mapStateToProps = (state) => ({
  themecolors: state.themeColors,
});

const CheckboxLabels = (props) => {

    const[state,setState] = useState ({
      checked: props.checked,
      indeterminate: props.indeterminate || false,
    })


    useEffect(()=>{
      setState(prevState=>({
        ...prevState,
        checked: props.checked,
        indeterminate: props.indeterminate || false,
      }))
    },[props.checked,props.indeterminate])
  

 const handleChange = (name) => (event) => {
    if (event.target.checked === true && !props.canAssign) {
      props.dispatch(
      notifyError( 'No Access for assign')
      );
    }
    if (event.target.checked === false && !props.canRemove) {
      props.dispatch(
      notifyError( 'No Access for unassign')

      );
    }
    if (event.target.checked === true && props.canAssign) {
      setState(prevState=>({
        ...prevState,checked: event.target.checked }));
      props.onChange(event, name);
    } else if (event.target.checked === false && props.canRemove) {
      setState(prevState=>({
        ...prevState,checked: event.target.checked }));
      props.onChange(event, name);
    }
  };

    const { checked, indeterminate } = state;
    const { themecolors } = props;
    return (
      <div style={{ margin: '5px' }}>
        <div>
          <FormControlLabel
            control={
              <Checkbox
                icon={
                  <svg  stroke={themecolors?.id===4?themecolors?.textColor:"white"} width={18} height={18}>
                    {/* Add your UncheckIcon rendering logic here */}
                    <use color={themecolors?.id===4?themecolors?.textColor:"white"} xlinkHref={`${UncheckIcon}#icon`} />
                  </svg>
                }
                checkedIcon={
                  <svg stroke={themecolors?.id===4?themecolors?.textColor:"white"}  width={18} height={18}>
                    {/* Add your CheckIcon rendering logic here */}
                    <use color={themecolors?.id===4?themecolors?.textColor:"white"} xlinkHref={`${CheckIcon}#icon`} />
                  </svg>
                }
                disableRipple
                checked={checked ? true : false}
                indeterminate={indeterminate}
                readOnly={props.readonly}
                onChange={handleChange(
                  props.value || props.id
                )}
                sx={{ m: '3px', p: 0, color: themecolors?.textColor }}
                color="default"
              />
            }
            label={props.label || ''}
            style={{ marginLeft: '5px', fontSize: '0.875rem', color: themecolors?.textColor}}
          />
        </div>
      </div>
    );
  }

export default connect(mapStateToProps)(CheckboxLabels);
